export interface BookingConfig {
  minDaysFromToday: number;
  isBookingHoldEnabled: boolean;
}

// Configuration for booking behavior
export const bookingConfig: BookingConfig = {
  // Minimum days from current date for booking (10 means user can only book from 11th day onwards)
  minDaysFromToday: 10,
  
  // Enable booking hold mode - controlled by environment variable REACT_APP_BOOKING_HOLD_ENABLED
  // Defaults to false if not set
  isBookingHoldEnabled: process.env.REACT_APP_BOOKING_HOLD_ENABLED === 'true',
};

// Message shown when booking is on hold
export const bookingHoldMessage = "Thank you for your interest and trust in us. Due to a high demand for services on your selected date, our Acharyas are currently fully booked. Our team is checking the next available dates and will get back to you at the earliest with suitable options. We truly appreciate your patience and look forward to serving you.";